import { createSlice } from "@reduxjs/toolkit";

export const companySettingSlice = createSlice({
  name: "companySetting",
  initialState: {
    getCompanySettingResult: false,
    getCompanySettingLoading: false,
    getCompanySettingError: false,
    addCompanySettingResult: false,
    addCompanySettingLoading: false,
    deleteCompanySettingResult: false,
  },
  reducers: {
    companySettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_COMPANYSETTING":
          return {
            ...state,
            getCompanySettingResult: payload.data,
            getCompanySettingLoading: payload.loading,
            getCompanySettingError: payload.error,
          };
        case "ADD_COMPANYSETTING":
          return {
            ...state,
            addCompanySettingResult: payload.data,
            addCompanySettingLoading: payload.loading,
          };
        case "DELETE_COMPANYSETTING":
          return {
            ...state,
            deleteCompanySettingResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { companySettingReducers } = companySettingSlice.actions;

export default companySettingSlice.reducer;
